// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Hexagon-module--wrapper--2dnk0","hexagon":"Hexagon-module--hexagon--10B5X","stroke":"Hexagon-module--stroke--OpC9X"};